var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticStyle:{"width":"100%","height":"100%","background-color":"#000","object-fit":"cover"},attrs:{"controls":"","src":"https://fc-transvideo.baidu.com/cbb56918bd7bb2db358298352b7d286d_1920_1080.mp4","preload":"auto"}})}
var staticRenderFns = []

export { render, staticRenderFns }